var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3804 0.921875H9.47563C4.67602 0.921875 0.785156 4.81274 0.785156 9.61235V23.5171C0.785156 28.3167 4.67602 32.2076 9.47563 32.2076H23.3804C28.18 32.2076 32.0709 28.3167 32.0709 23.5171V9.61235C32.0709 4.81274 28.18 0.921875 23.3804 0.921875ZM29.0292 23.5171C29.0196 26.6328 26.4961 29.1564 23.3804 29.1659H9.47563C6.35984 29.1564 3.83637 26.6328 3.82682 23.5171V9.61235C3.83637 6.49655 6.35984 3.97308 9.47563 3.96354H23.3804C26.4961 3.97308 29.0196 6.49655 29.0292 9.61235V23.5171ZM24.684 10.0469C25.6439 10.0469 26.4221 9.2687 26.4221 8.30878C26.4221 7.34886 25.6439 6.57068 24.684 6.57068C23.724 6.57068 22.9459 7.34886 22.9459 8.30878C22.9459 9.2687 23.724 10.0469 24.684 10.0469ZM16.428 8.7433C12.1084 8.7433 8.60659 12.2451 8.60659 16.5647C8.60659 20.8844 12.1084 24.3862 16.428 24.3862C20.7477 24.3862 24.2494 20.8844 24.2494 16.5647C24.2541 14.4889 23.4315 12.4968 21.9637 11.029C20.4959 9.56123 18.5038 8.73868 16.428 8.7433ZM11.6483 16.5647C11.6483 19.2046 13.7882 21.3445 16.428 21.3445C19.0678 21.3445 21.2078 19.2046 21.2078 16.5647C21.2078 13.9249 19.0678 11.785 16.428 11.785C13.7882 11.785 11.6483 13.9249 11.6483 16.5647Z",
    fill: "#161614"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.126d16b38efdd240248af05394210c1f.svg";
export { ForwardRef as ReactComponent };